"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright © 2020 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * Combines multiple streams into a single subscription provider.
 *
 * @param {Array} streams - An array of (async) stream functions.
 * @returns {object} The stream subscription object with the `on` function for
 * attaching listeners and the `close` function to close the stream.
 */
var combinedStream = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(streams) {
    var subscribers;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!(streams instanceof Array) || streams.length === 0)) {
              _context.next = 4;
              break;
            }

            throw new Error('Cannot combine streams with invalid stream array.');

          case 4:
            if (!(streams.length === 1)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", streams[0]);

          case 6:
            _context.next = 8;
            return Promise.all(streams);

          case 8:
            subscribers = _context.sent;
            return _context.abrupt("return", {
              on: function on(eventName, callback) {
                var _iterator = _createForOfIteratorHelper(subscribers),
                    _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var subscriber = _step.value;
                    subscriber.on(eventName, callback);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              },
              close: function close() {
                var _iterator2 = _createForOfIteratorHelper(subscribers),
                    _step2;

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var subscriber = _step2.value;
                    subscriber.close();
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function combinedStream(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _default = combinedStream;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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